import { type Documentation, documentationSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

interface Params {
  projectId: string;
  documentationId: string;
  noRetry?: boolean;
  refetchInterval?: number | false;
}

export function useReport({
  projectId,
  documentationId,
  noRetry = false,
  refetchInterval = false,
}: Params) {
  const queryKey = ['reports', { projectId, documentationId }];
  const url = `/projects/${projectId}/reports/${documentationId}`;

  const {
    data: report,
    error,
    isLoading,
    isFetching,
    refetch,
  } = useQuery<Documentation>({
    queryKey,
    queryFn: () => get({ url, schema: documentationSchema }),
    enabled: !!projectId && !!documentationId,
    retry: !noRetry,
    refetchInterval: (query) =>
      ['generated', 'failed'].includes(query.state.data?.status ?? '') ? false : refetchInterval,
  });

  return {
    report,
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
